import React from 'react'
import { Button, Box } from '@chakra-ui/react'
import { useForm, FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  CompanyTaxInvoiceForm,
  TaxIdType,
  BranchType,
} from '@/features/free-trial/components/CompanyTaxInvoiceForm'
import { CheckoutCompanyFormValues } from './types'
import { boxStyle, buttonStyle } from './styles'

interface CheckoutCompanyFormProps {
  onSubmit: (values: CheckoutCompanyFormValues) => void
  onCancel: () => void
  defaultValues?: Partial<CheckoutCompanyFormValues>
  isEditMode?: boolean
}

export const CheckoutCompanyForm = ({
  onSubmit,
  defaultValues,
  isEditMode = false,
}: CheckoutCompanyFormProps): React.ReactElement => {
  const { t } = useTranslation(['payment'])

  const methods = useForm<CheckoutCompanyFormValues>({
    defaultValues: {
      tax_id_type: TaxIdType.Thai,
      branch_type: BranchType.Headquarter,
      primary: false,
      ...defaultValues,
    },
  })

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CompanyTaxInvoiceForm />

        <Box {...boxStyle}>
          <Button
            {...buttonStyle}
            type="submit"
            isLoading={isSubmitting}
            loadingText={t('common.saving')}
          >
            {isEditMode ? t('checkout.update') : t('checkout.save')}
          </Button>
        </Box>
      </form>
    </FormProvider>
  )
}
